<script>
    export default {
        methods: {
            filterNotDefaultParameters(object) {
                let outer_object = {};
                Object.entries(object).forEach(entry => {
                    const [key, value] = entry;
                    switch (key) {
                        case 'priceMax':
                            if (value != this.max_price) {
                                outer_object[key] = value;
                            }
                            break;
                        case 'priceMin':
                            if (value != this.min_price) {
                                outer_object[key] = value;
                            }
                            break;
                        case 'sort':
                            if (value != 'default') {
                                outer_object[key] = value;
                            }
                            break;
                        case 'page':
                            break;
                        default:
                            if (value.length !== 0) {
                                outer_object[key] = value;
                            }
                            break;
                    }
                });
                return outer_object;
            },
            // Old method with return all if something exists
            // filterNotDefaultParameters(object) {
            //     let active = false;
            //     Object.entries(object).forEach(entry => {
            //         const [key, value] = entry;
            //         switch (key) {
            //             case 'priceMax':
            //                 if (value != this.max_price) {
            //                     active = true;
            //                 }
            //                 break;
            //             case 'priceMin':
            //                 if (value != this.min_price) {
            //                     active = true;
            //                 }
            //                 break;
            //             case 'sort':
            //                 if (value != 'default') {
            //                     active = true;
            //                 }
            //                 break;
            //             case 'page':
            //                 break;
            //             default:
            //                 if (value.length !== 0) {
            //                     active = true;
            //                 }
            //                 break;
            //         }
            //     });
            //     if (active) {
            //         return object;
            //     } else {
            //         return {};
            //     }
            // }
        }
    }
</script>